import { SxProps, Theme } from '@mui/material/styles';
import { colorPrimitives, radiusPrimitives } from '../tokens/primitives';
import { semanticTokens } from '../tokens/semantic';

export const textFieldRecipeStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: radiusPrimitives.sm,
    backgroundColor: semanticTokens.surface.card,
    overflow: 'hidden',
    '& fieldset': {
      borderColor: semanticTokens.border.input,
      borderWidth: '0.0625rem',
    },
    '&:hover fieldset': {
      borderColor: 'primary.main',
      borderWidth: '0.125rem',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'primary.main',
      borderWidth: '0.125rem',
    },
  },
  '& .MuiInputBase-input': {
    color: semanticTokens.text.primary,
    WebkitTextFillColor: semanticTokens.text.primary,
  },
  '& .MuiInputBase-input:-webkit-autofill': {
    WebkitTextFillColor: semanticTokens.text.primary,
    boxShadow: `0 0 0 1000px ${semanticTokens.surface.card} inset`,
    WebkitBoxShadow: `0 0 0 1000px ${semanticTokens.surface.card} inset`,
    caretColor: semanticTokens.text.primary,
  },
  '& .MuiInputLabel-root': {
    color: '#666666',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'primary.main',
  },
  '& .MuiFormHelperText-root': {
    color: semanticTokens.text.muted,
  },
};

export const decoratedTextFieldRecipeStyles = {
  ...textFieldRecipeStyles,
  '& .MuiSvgIcon-root': {
    color: colorPrimitives.primary[600],
  },
  '& .MuiIconButton-root .MuiSvgIcon-root': {
    color: semanticTokens.icon.subdued,
  },
};

export const textFieldRecipeSx: SxProps<Theme> = textFieldRecipeStyles;

export const decoratedTextFieldRecipeSx: SxProps<Theme> =
  decoratedTextFieldRecipeStyles;